export default __webpack_public_path__ + "static/media/spud_wordart_logo.6b0e32ba.png";